// Dependencies
import React from "react";
import { Widget } from "@typeform/embed-react";
// import MetaTags from "react-meta-tags";

// Styling
import { TextContainer } from "styling/GlobalStyling";

// Components
import { PageHeading } from "../components/PageHeading";

// Candidate SIGN UP FORM --------------------------------------
export const SignUpForm = () => {
  return (
    <>
      {/* <MetaTags>
        <meta charset="utf-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <title>We Exist - För queens</title>
        <meta
          name="description"
          content="Är du kvinna och jobbar inom tech & it? Då har du kommit rätt! Hos oss kan du hitta ditt nästa drömjobb 
          samt ta del av vårt kvinnliga nätverk."
        />
        <meta property="og:title" content="We Exist - För queens" />
        <meta
          property="og:description"
          content="Är du kvinna och jobbar inom tech & it? Då har du kommit rätt! Hos oss kan du hitta ditt nästa drömjobb 
          samt ta del av vårt kvinnliga nätverk."
        />
        <meta property="og:image" content="service-images/rekrytering.jpg" />
      </MetaTags> */}

      <PageHeading title="För queens" />
      <TextContainer>
        <p>
          Våra kandidater är våra queens{" "}
          <span role="img" aria-label="orange heart">
            🧡
          </span>{" "}
          <br />
          Vi har ett enormt stort nätverk av kvinnliga superstars med kompetens
          inom tech och it och vi växer så det knakar. Genom att vara en del av
          vårt nätverk får du möjlighet att inspireras, motiveras samt lyftas av
          andra kvinnor i branschen. Du kommer även bli bjuden till mingel,
          event och föreläsningar som gynnar din personliga utveckling och
          karriär. Oavsett om du söker nytt jobb just nu eller inte så är du
          alltid varmt välkommen att ta del av vårt nätverk. Det är självklart
          gratis och vi strävar efter att bygga ett av Sveriges största
          kvinnliga communities inom tech och it.
          <br />
          <br />
          Om du söker jobb via oss kommer vi hjälpa dig att matchas med företag
          som aktivt arbetar med jämställdhet och inkludering. Vi jobbar med
          många företag men långt ifrån alla som kontaktar oss, vi tackar endast
          JA till att jobba med företag som är villiga att engagera sig till
          100% och att aktivt jobba med jämställdhetsfrågan på ett långsiktigt
          plan.
          <br />
          <br />
          <b>
            Anmäl ditt intresse genom att maila <b>hello@weexist.se</b> eller
            registrera dig nedan för att bli en av vårt kvinnliga nätverk redan
            idag.
          </b>
        </p>
      </TextContainer>
      <Widget id="WMhxTtWW" style={{ width: "100%" }} className="form-widget" />
    </>
  );
};
